export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  sortField: string;
  sortOrder: string;
  filter:{
    searchText:string
    status:number
  }
};

export type MasterTableDataType = {
  loincName: string;
  loincValue: string;
  loincClinicId: number;
  loincStatus: number;
  loincId: number;
  loincCreatedById: number;
  loincCreatedDate: string;
  loincCode:string
};


export type MasterDataType = {
  clinicId: number;
  code: string;
  createdById: number;
  name: string;
  status: number;
  value: string;
  loincId?: number | null;
};



export type SaveResponseType = {};

export type MasterFormDataType = {
  code: string;
  name: string;
  value: string;
  status:number
};

export const initialFormData: MasterFormDataType = {
  code: "",
  name: "",
  value: "",
  status:1
};
